// @angular
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

// @angular/material
import { MatNativeDateModule } from "@angular/material/core";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatMenuModule } from "@angular/material/menu";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatSelectModule } from "@angular/material/select";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatInputModule } from "@angular/material/input";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatTableModule } from "@angular/material/table";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSortModule } from "@angular/material/sort";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatDialogModule } from "@angular/material/dialog";

// @ng-select
import { NgSelectModule } from "@ng-select/ng-select";
// import { NgOptionHighlightModule } from "@ng-select/ng-option-highlight";

// Other
// import { TooltipModule } from "ng2-tooltip-directive";

// Shared Components
import { PhotoPreviewComponent } from "./components/photo-preview/photo-preview";
import { ChangePasswordComponent } from "../lib/components/change-password/change-password";
import { DraftsComponent } from "../lib/components/drafts/drafts.component";
import { InboxComponent } from "../lib/components/inbox/inbox.component";
import { MessageDetailComponent } from "../lib/components/message-detail/message-detail.component";
import { MessageDraftComponent } from "../lib/components/new-message-draft/message-draft.component";
import { SentComponent } from "../lib/components/sent/sent.component";
import { PurchaseComponent } from "../lib/stripe/purchase/purchase.component";
import { TransactionCompleteComponent } from "../lib/stripe/transaction-complete/transaction-complete";
import { ContactsComponent } from "./components/contacts/contacts.component";
import { RouterModule } from "@angular/router";
import { LoadingComponent } from "./components/loading/loading.component";
import { OutsideClickDirective } from "./directives/outsideClick";
import { GiveCreditsComponent } from "./components/give-credits/give-credits.component";
import { UploadComponent } from "./components/upload/upload.component";
import { SelectContactSearchComponent } from "./components/select-contact-search/select-contact-search.component";
import { JhmTableComponent } from "./components/jhm-table/jhm-table.component";
import { CentsToDollarsPipe } from "../public-api";
import { ToastComponent } from "./components/toast/toast.component";

@NgModule({
	exports: [
		PhotoPreviewComponent,
		ChangePasswordComponent,
		DraftsComponent,
		InboxComponent,
		JhmTableComponent,
		MessageDetailComponent,
		MessageDraftComponent,
		PurchaseComponent,
		SentComponent,
		TransactionCompleteComponent,
		ToastComponent,
		ContactsComponent,
		GiveCreditsComponent,
		OutsideClickDirective,
		BrowserModule,
		BrowserAnimationsModule,
		LoadingComponent,
		MatTableModule,
		MatFormFieldModule,
		MatTooltipModule,
		// TooltipModule,
		MatSelectModule,
		MatCheckboxModule,
		MatSortModule,
		MatInputModule,
		MatCheckboxModule,
		FormsModule,
		ReactiveFormsModule,
		MatMenuModule,
		MatIconModule,
		MatPaginatorModule,
		MatRadioModule,
		MatSlideToggleModule,
		NgSelectModule,
		// NgOptionHighlightModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatAutocompleteModule,
		MatToolbarModule,
		MatDialogModule,
		UploadComponent,
		SelectContactSearchComponent
	],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		MatTableModule,
		MatFormFieldModule,
		MatTooltipModule,
		// TooltipModule,
		MatSelectModule,
		MatCheckboxModule,
		MatSortModule,
		MatInputModule,
		MatCheckboxModule,
		FormsModule,
		ReactiveFormsModule,
		MatMenuModule,
		MatIconModule,
		MatPaginatorModule,
		MatRadioModule,
		MatSlideToggleModule,
		NgSelectModule,
		// NgOptionHighlightModule,
		MatDatepickerModule,
		MatNativeDateModule,
		MatAutocompleteModule,
		MatToolbarModule,
		MatDialogModule,
		RouterModule,
		PhotoPreviewComponent,
		ChangePasswordComponent,
		DraftsComponent,
		InboxComponent,
		JhmTableComponent,
		MessageDetailComponent,
		MessageDraftComponent,
		PurchaseComponent,
		SentComponent,
		TransactionCompleteComponent,
		ToastComponent,
		ContactsComponent,
		GiveCreditsComponent,
		LoadingComponent,
		OutsideClickDirective,
		UploadComponent,
		SelectContactSearchComponent
	],
	providers: [
		provideHttpClient(withInterceptorsFromDi()),
		CentsToDollarsPipe
	]
})
export class SharedModule
{ }
